import { IBienLaiSelectByLopRequest } from "../../../model/request/bien-lai/IBienLaiSelectByLopRequest";
import { IBienLaiThuViewModel } from "../../../model/respone/bien-lai/IBienLaiThu";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IBienLaiViewTheoLopBaseActionTypes<T> {
  request: IBienLaiSelectByLopRequest;
  data: T;
}
export const eBienLaiViewTheoLopActionsObj = {
  LOAD_START: {} as IBienLaiSelectByLopRequest,
  LOAD_SUCCESS: {} as IBienLaiViewTheoLopBaseActionTypes<
    IBienLaiThuViewModel[]
  >,
  LOAD_ERRR: {} as IBienLaiViewTheoLopBaseActionTypes<string>,
};
export const eBienLaiViewTheoLopActionTypeIds = generateActionTypeIds(
  eBienLaiViewTheoLopActionsObj,
  "BIEN_LAI_VIEW_THEO_LOP"
);
export type IBienLaiViewTheoLopActionTypes = IGenericActionType<
  typeof eBienLaiViewTheoLopActionsObj,
  "BIEN_LAI_VIEW_THEO_LOP"
>;
